import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Image } from "react-bootstrap";
import { RelatedBlogsSidebar } from "./RelatedBlogsSidebar";
import { PageNotFound } from "../";
import { blogPostAPI } from "../../../services/publicPages";
import styles from "./resources.module.css";
import { LoadingDots, ServerDown } from "../../../components/general";
import { CkEditorContent } from "../../../components/general/CkEditorContent";

export const BlogDetail = () => {
  const { i18n } = useTranslation();
  const { slug } = useParams();
  const [blog, setBlog] = useState({});
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [serverUnavailable, setServerUnavailable] = useState(false);
  const [pageNotFound, setPageNotFound] = useState(false);
  const paddingDirection = i18n.dir() === "ltr" ? "pe-md-4" : "ps-md-4";

  // fetch blog content
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await blogPostAPI(slug);
        setBlog(response.data);
        setRelatedBlogs(response.data?.related_blogs);
        setLoading(false);
      } catch (err) {
        if (!err?.response) {
          setServerUnavailable(true);
          setLoading(false);
        } else if (err?.response?.status === 404) {
          setPageNotFound(true);
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [slug]);

  function isEmptyHtml(str) {
    if (!str) return true;
    const text = str.replace(/<[^>]*>/g, "").trim(); // remove tags + trim
    return text.length === 0;
  }

  return (
    <>
      {loading && <LoadingDots />}
      {serverUnavailable && <ServerDown />}
      {pageNotFound && <PageNotFound />}
      {!loading && !serverUnavailable && !pageNotFound && (
        <Container className="my-5">
          <Row>
            <Col md={8} className={`${paddingDirection} ${styles.blogContainer}`}>
              {/* Blog Title */}
              <h2 className="mb-4 fw-bold">{blog[`title_${i18n.language}`] || blog.title}</h2>

              {/* Blog Image */}
              <Image
                fluid
                src={blog[`cover_image_${i18n.language}`] || blog.cover_image}
                className="mb-3"
              />

              {/* Blog Content */}
              <CkEditorContent
                html={
                  isEmptyHtml(blog[`content_${i18n.language}`])
                    ? blog.content
                    : blog[`content_${i18n.language}`]
                }
              />
            </Col>

            {/* Related Posts */}
            {relatedBlogs.length > 0 && (
              <Col md={4} className={styles.stickySidebarContainer}>
                <div className={styles.stickySidebarContent}>
                  <RelatedBlogsSidebar relatedBlogs={relatedBlogs} />
                </div>
              </Col>
            )}
          </Row>
        </Container>
      )}
    </>
  );
};
